import { render } from "./GuideQuickStart.vue?vue&type=template&id=69024baa&scoped=true"
import script from "./GuideQuickStart.vue?vue&type=script&lang=js"
export * from "./GuideQuickStart.vue?vue&type=script&lang=js"

import "./GuideQuickStart.vue?vue&type=style&index=0&id=69024baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69024baa"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QBanner,QIcon});
